var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 15.3071C7.40238 15.3071 3.30176 8.45981 3.30176 5.79244C3.30176 2.65031 5.85776 0.09375 8.99988 0.09375C12.1426 0.09375 14.6986 2.65031 14.6986 5.79244C14.698 8.45981 10.5974 15.3071 8.99988 15.3071ZM8.99988 1.842C6.82132 1.842 5.04888 3.61388 5.04888 5.79244C5.04888 7.78763 7.88895 12.1386 8.99988 13.3496C10.1119 12.1391 12.9514 7.78763 12.9514 5.79244C12.9514 3.61388 11.1784 1.842 8.99988 1.842Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99963 7.67894C10.1385 7.67894 11.0618 6.75569 11.0618 5.61681C11.0618 4.47793 10.1385 3.55469 8.99963 3.55469C7.86075 3.55469 6.9375 4.47793 6.9375 5.61681C6.9375 6.75569 7.86075 7.67894 8.99963 7.67894Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00025 17.9064C11.2311 17.9064 13.0396 17.4289 13.0396 16.8399C13.0396 16.2509 11.2311 15.7734 9.00025 15.7734C6.7694 15.7734 4.96094 16.2509 4.96094 16.8399C4.96094 17.4289 6.7694 17.9064 9.00025 17.9064Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMapIcon);
export default __webpack_public_path__ + "static/media/new-map-icon.cd991719cea28bd8f37eea8fcc7ea3d6.svg";
export { ForwardRef as ReactComponent };